/* Tchin — couche de finition (révélations, chargement d'images, barre d'achat mobile). */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* --- 1. Révélation au scroll --- */
  function setupReveal() {
    if (reduced) return;

    var blocks = ['.tc-quick-faq', '.tc-transition', '.ts-header', '.tc-story', '.tc-compare', '.tc-faq', '.tc-end'];
    var groups = ['.ts-grid', '.tc-stats-grid', '.tc-transition-facts'];

    var targets = [];
    blocks.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.classList.add('tcp-reveal');
        targets.push(el);
      });
    });
    groups.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.classList.add('tcp-stagger');
        targets.push(el);
      });
    });

    if (!targets.length) return;

    // Balayage au scroll plutôt qu'un IntersectionObserver : celui-ci ne notifie pas
    // quand un bloc passe de « sous l'écran » à « au-dessus » en une seule frame
    // (ancre, scroll restauré, Cmd+Flèche bas), ce qui le laissait invisible.
    var pending = targets.slice();
    var ticking = 0;

    function sweep() {
      var limit = window.innerHeight * 0.92;
      pending = pending.filter(function (el) {
        if (el.getBoundingClientRect().top >= limit) return true;
        el.classList.add('tcp-in');
        return false;
      });
      if (!pending.length) {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
      }
    }

    // Throttle par horloge plutôt que requestAnimationFrame : rAF est suspendu
    // dans un onglet en arrière-plan, ce qui laisserait la page vide à l'ouverture.
    function onScroll() {
      var now = Date.now();
      if (now - ticking < 100) return;
      ticking = now;
      sweep();
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    sweep();
  }

  /* --- 2. Arrivée en fondu des images --- */
  function setupImages() {
    var imgs = document.querySelectorAll('.ts-photo, .tc-main-image img, .tc-story-image img');
    imgs.forEach(function (img) {
      if (img.complete && img.naturalWidth > 0) {
        img.classList.add('tcp-loaded');
        return;
      }
      img.addEventListener('load', function () { img.classList.add('tcp-loaded'); }, { once: true });
      img.addEventListener('error', function () { img.classList.add('tcp-loaded'); }, { once: true });
    });
  }

  /* --- 3. Barre d'achat mobile --- */
  function setupBuyBar() {
    var form = document.querySelector('.tc form[action$="/cart/add"]');
    var cta = form && form.querySelector('.tc-cta');
    if (!form || !cta) return;

    var bar = document.createElement('div');
    bar.className = 'tcp-buybar';
    bar.innerHTML =
      '<span class="tcp-buybar-info">' +
      '<span class="tcp-buybar-label">Tchin Lendemain</span>' +
      '<span class="tcp-buybar-price"></span>' +
      '</span>' +
      '<button type="button" class="tcp-buybar-btn">Ajouter au panier</button>';

    var priceEl = bar.querySelector('.tcp-buybar-price');

    function syncPrice() {
      // Le libellé du CTA contient le total de l'offre sélectionnée.
      var match = cta.textContent.match(/[\d  ]+[.,]\d{2}\s*€|€\s*[\d  ]+[.,]\d{2}/);
      priceEl.textContent = match ? match[0].trim() : '';
    }

    syncPrice();
    form.addEventListener('change', function () { window.setTimeout(syncPrice, 60); });

    bar.querySelector('.tcp-buybar-btn').addEventListener('click', function () {
      if (typeof form.requestSubmit === 'function') form.requestSubmit(cta);
      else cta.click();
    });

    document.body.appendChild(bar);

    if (!('IntersectionObserver' in window)) {
      bar.classList.add('tcp-show');
      return;
    }

    new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('tcp-show', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      },
      { threshold: 0 }
    ).observe(cta);
  }


  /* --- 4. Galerie verrouillee : clavier + anti glisser-deposer --- */
  function setupGalleryKeys() {
    var slider = document.querySelector('.tc-slider');
    var thumbs = [].slice.call(document.querySelectorAll('.tc-thumb'));

    document.querySelectorAll('.tc-featured, .tc-thumb img, .tc-story-image img, .ts-photo')
      .forEach(function (im) { im.setAttribute('draggable', 'false'); });

    if (!slider || thumbs.length < 2) return;

    // Filet de securite : la galerie etant verrouillee sur ordinateur, les miniatures
    // sont le seul moyen de naviguer. Le theme les anime via scrollTo({behavior:'smooth'}),
    // qui ne demarre pas si requestAnimationFrame est suspendu (onglet en arriere-plan,
    // economie d'energie). Si rien n'a bouge, on repositionne sans animation.
    thumbs.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        var before = slider.scrollLeft;
        var target = slider.clientWidth * i;
        window.setTimeout(function () {
          if (slider.scrollLeft === before && Math.abs(before - target) > 4) {
            // scroll-behavior:smooth s'applique aussi a une affectation de scrollLeft :
            // on le neutralise le temps du saut, sinon on relance la meme animation bloquee.
            var prev = slider.style.scrollBehavior;
            slider.style.scrollBehavior = 'auto';
            slider.scrollLeft = target;
            slider.style.scrollBehavior = prev;
          }
        }, 400);
      });
    });


    // overflow-x:hidden sur ordinateur supprime le defilement par fleches :
    // on le readapte sur les miniatures pour ne pas perdre l'acces clavier.
    slider.addEventListener('keydown', function (e) {
      var dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
      if (!dir) return;
      var marker = document.querySelector('[data-current-slide]');
      var cur = marker ? parseInt(marker.textContent, 10) : 1;
      if (!cur) cur = 1;
      var next = Math.min(thumbs.length, Math.max(1, cur + dir));
      if (next === cur) return;
      e.preventDefault();
      thumbs[next - 1].click();
    });
  }

  /* --- 5. Option assurance : ajout / retrait de la ligne au panier --- */
  function setupInsurance() {
    // Delegation sur document : le tiroir se re-rend entierement a chaque mise a
    // jour du panier, un listener pose sur la case serait perdu.
    document.addEventListener('change', function (e) {
      var box = e.target && e.target.closest ? e.target.closest('[data-tcp-insurance]') : null;
      if (!box) return;
      var variant = parseInt(box.getAttribute('data-variant'), 10);
      if (!variant) return;

      var row = box.closest('.tcp-insurance');
      if (row) row.classList.add('is-busy');

      var drawer = document.querySelector('cart-drawer');
      var sections = [];
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      }

      var plan;
      if (box.checked) {
        plan = Promise.resolve({ url: '/cart/add.js', body: { items: [{ id: variant, quantity: 1 }] } });
      } else {
        // /cart/change.js rejette un id numerique : il attend la cle de ligne
        // ("<variant>:<hash>"), qu'on relit dans le panier courant.
        plan = fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var line = cart.items.filter(function (i) { return i.variant_id === variant; })[0];
            if (!line) return null;
            return { url: '/cart/change.js', body: { id: line.key, quantity: 0 } };
          });
      }

      plan
        .then(function (req) {
          if (!req) { if (row) row.classList.remove('is-busy'); return null; }
          if (sections.length) {
            req.body.sections = sections;
            req.body.sections_url = window.location.pathname;
          }
          return fetch(req.url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(req.body)
          }).then(function (r) { return r.json(); });
        })
        .then(function (parsed) {
          if (!parsed) return;
          if (drawer && parsed.sections) drawer.renderContents(parsed);
          else window.location.reload();
        })
        .catch(function () { window.location.reload(); });
    });
  }

  onReady(function () {
    setupReveal();
    setupImages();
    setupBuyBar();
    setupGalleryKeys();
    setupInsurance();
  });
})();
